import { ConsignmentRootDataContext } from 'Pages/UserDashboard/Consignment/Contexts/ConsignmentRootData';
import { useContext, useEffect, useState } from 'react';
import { IconContext } from 'react-icons';
import { CgChevronLeft, CgChevronRight } from 'react-icons/cg';

interface IPaginationProps {
  paginationData: any;
}

const Pagination: React.FC<IPaginationProps> = (props) => {
  const { paginationData: paginationDataFromProps } = props;
  const consignmentContext = useContext(ConsignmentRootDataContext);
  const form = consignmentContext.value.formTabToolbar;
  const firstRender = consignmentContext.value.isFirstRenderTabToolbar;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousPage, setPreviousPage] = useState(1);
  const [startCountingPagination, setStartCountingPagination] = useState(false);
  const [paginationData, setPaginationData] = useState({
    current_page: currentPage,
    ...paginationDataFromProps,
  });

  const arrayOfNumberPagination = new Array(
    paginationData.last_page === 0 ? 1 : paginationData.last_page,
  )
    .fill(1)
    .map((value, index) => index + 1);
  const lastPage = arrayOfNumberPagination.length;
  let newArrayPagination =
    window.innerWidth > 1095
      ? lastPage < 6
        ? arrayOfNumberPagination
        : arrayOfNumberPagination.slice(currentIndex, currentIndex + 5)
      : lastPage < 4
      ? arrayOfNumberPagination
      : arrayOfNumberPagination.slice(
          currentIndex === 0 ? 0 : currentIndex - 1,
          currentIndex === 0 ? 3 : currentIndex + 2,
        );

  const setPage = (param: number) => {
    form?.setFieldValue('page', param);
  };

  const handleNextPage = () => {
    if (currentPage !== lastPage) {
      setPreviousPage(currentPage);
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage !== 1) {
      setPreviousPage(currentPage);
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    if (!paginationDataFromProps) {
      return;
    }

    if (paginationDataFromProps?.current_page) {
      setCurrentPage(paginationDataFromProps.current_page);
    }

    setPaginationData({
      ...paginationDataFromProps,
    });
  }, [paginationDataFromProps]);

  useEffect(() => {
    // On desktop, pagination number is up to 5 page
    // On Mobile, pagination number is only 3 page
    if (window.innerWidth > 1095) {
      if (currentPage > 2) {
        setStartCountingPagination(true);
      }

      if (!firstRender) {
        setPage(currentPage);
        const lastPage = paginationData.last_page;
        const lastIndexCondition = lastPage - currentPage;
        const lastIndexCalculation = currentPage - previousPage;
        const firstIndexCondition = currentPage - 2;
        const firstIndexCalculation = previousPage - currentPage;

        if (previousPage < currentPage) {
          if (startCountingPagination && lastIndexCondition <= 2) {
            setCurrentIndex(lastPage - 5);
          } else if (
            startCountingPagination &&
            lastIndexCondition > 1 &&
            firstIndexCondition > 1
          ) {
            setCurrentIndex(
              currentIndex +
                (lastIndexCalculation > 2 ? lastIndexCalculation - 2 : 1),
            );
          }
        } else {
          if (startCountingPagination && firstIndexCondition <= 1) {
            setCurrentIndex(0);
          } else if (
            startCountingPagination &&
            firstIndexCondition > 1 &&
            lastIndexCondition > 2
          ) {
            setCurrentIndex(
              currentIndex -
                (firstIndexCalculation > 2 ? firstIndexCalculation - 2 : 1),
            );
          }
        }
      }
    } else {
      if (currentPage > 1) {
        setStartCountingPagination(true);
      }

      if (!firstRender) {
        setPage(currentPage);
        const lastPage = paginationData.last_page;
        const lastIndexCondition = lastPage - currentPage;
        const lastIndexCalculation = currentPage - previousPage;
        const firstIndexCondition = currentPage - 1;
        const firstIndexCalculation = previousPage - currentPage;

        if (previousPage < currentPage) {
          setCurrentIndex(
            currentIndex +
              (lastIndexCalculation > 1 ? lastIndexCalculation - 1 : 1),
          );
        } else {
          setCurrentIndex(
            currentIndex -
              (firstIndexCalculation > 1 ? firstIndexCalculation - 1 : 1),
          );
        }
      }
    }
  }, [currentPage, startCountingPagination]);

  return (
    <div className={'pagination-container'}>
      <IconContext.Provider value={{ color: '#242424', size: '14px' }}>
        <div className={'pagination-control'} onClick={handlePrevPage}>
          <CgChevronLeft />
        </div>
      </IconContext.Provider>
      {newArrayPagination.map((v, i) => {
        if (!v) return;
        const onClick = () => {
          if (v !== currentPage && typeof v === 'number') {
            setPreviousPage(currentPage);
            setCurrentPage(v);
          }
        };
        return (
          <div
            className={
              v === currentPage ? 'pagination-item-active' : 'pagination-item'
            }
            key={i}
            onClick={onClick}
          >
            {v}
          </div>
        );
      })}
      <IconContext.Provider value={{ color: '#242424', size: '14px' }}>
        <div className={'pagination-control'} onClick={handleNextPage}>
          <CgChevronRight />
        </div>
      </IconContext.Provider>
    </div>
  );
};

export default Pagination;
